<template>
  <footer>
    <div class="inner">
      <div class="attention">
        <div>
          <img class="pc" src="../assets/img/common/logo_asagaku_pc.png" alt="朝日学生新聞社">
          <img class="sp" src="/img/logo_asagaku_sp.png" alt="朝日学生新聞社">
        </div>
        <p>本ウェブサイトに掲載されている記事、写真、イラストなどの文字・画像等のコンテンツの無断転載を禁じます。<br>すべての著作権は運営会社である朝日学生新聞社およびコンテンツ提供者に帰属します。</p>
      </div>
      <footnav></footnav>
    </div>
    <p class="copy">Copyright &copy; Asahi Gakusei Shinbunsha <br>All Rights Reserved.</p>
  </footer>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
footer {
  .inner {
    background: #fff;
    align-items: center;
    padding-top: 30px;
    .attention {
      @include flex(left);
      -ms-flex-align: flex-start;
      -webkit-align-items: flex-start;
      align-items: flex-start;
      width: 86.6%;
      max-width: 866px;
      margin: 0 auto;
      img {
        height: auto;
      }
      p {
        padding-top: 20px;
        padding-left: 40px;
        font-size: 12px;
        line-height: 2;
        font-weight: bold;
        letter-spacing: 0.18em;
      }
    }
  }
  .copy {
    line-height: 70px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    background: #000;
    br {
      display: none;
    }
  }

  @media only screen and (max-width: 750px) {
    .inner {
      padding: 0;
      .attention {
        display: block;
        width: 100%;
        img {
          width: 47.5vw;

          margin: 0 auto;
          padding: 6.5vw 0;
        }
        p {
          padding: 0 5.35vw 6.5vw;
          font-size: 0.8rem;
        }
      }
    }
    .copy {
      padding: 5.5vw 0 5.55vw;
      line-height: 1.4;
      letter-spacing: 0.1em;
      br {
        display: block;
      }
    }
  }
}
</style>

<script>
import footnav from "../components/footnav";

export default {
  name: "Footer",
  components: {
    footnav
  }
};
</script>
